import { gql } from 'apollo-angular';

export const ApplyVoucherFragment = gql`
  fragment ApplyVoucher on OrderOutput {
    id
    dateTimeToLive
    screeningItems {
      id
      seatId
      screeningId
      ticketId
      seat
      row
      price
      voucherNumber
      name
      printoutName
    }
  }
`;
